
import * as PGFuZHJvaWR4LmNvbGxlY3Rpb246Y29sbGVjdGlvbj4 from './androidx-collection-collection-wasm-js.mjs';
import * as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg from './androidx-compose-runtime-runtime.mjs';
import * as PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtcnVudGltZT4 from './androidx-lifecycle-lifecycle-runtime.mjs';
import * as PGFuZHJvaWR4LnNhdmVkc3RhdGU6c2F2ZWRzdGF0ZS1jb21wb3NlPg from './androidx-savedstate-savedstate-compose.mjs';
import * as PGFuZHJvaWR4LnNhdmVkc3RhdGU6c2F2ZWRzdGF0ZT4 from './androidx-savedstate-savedstate.mjs';
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbGxlY3Rpb246Y29sbGVjdGlvbj4__ALL_EXPORTS } from './androidx-collection-collection-wasm-js.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS } from './androidx-compose-runtime-runtime.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtcnVudGltZT4__ALL_EXPORTS } from './androidx-lifecycle-lifecycle-runtime.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LnNhdmVkc3RhdGU6c2F2ZWRzdGF0ZS1jb21wb3NlPg__ALL_EXPORTS } from './androidx-savedstate-savedstate-compose.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LnNhdmVkc3RhdGU6c2F2ZWRzdGF0ZT4__ALL_EXPORTS } from './androidx-savedstate-savedstate.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const js_code = {

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<androidx.compose.runtime:runtime>': PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS,
    '<androidx.collection:collection>': PGFuZHJvaWR4LmNvbGxlY3Rpb246Y29sbGVjdGlvbj4__ALL_EXPORTS,
    '<androidx.savedstate:savedstate>': PGFuZHJvaWR4LnNhdmVkc3RhdGU6c2F2ZWRzdGF0ZT4__ALL_EXPORTS,
    '<androidx.savedstate:savedstate-compose>': PGFuZHJvaWR4LnNhdmVkc3RhdGU6c2F2ZWRzdGF0ZS1jb21wb3NlPg__ALL_EXPORTS,
    '<androidx.lifecycle:lifecycle-runtime>': PGFuZHJvaWR4LmxpZmVjeWNsZTpsaWZlY3ljbGUtcnVudGltZT4__ALL_EXPORTS,
};
    